type Props = {
  message: string
}

export default function ErrorResult({ message }: Props) {
  return (
    <div className="mt-6 p-4 bg-red-100 text-red-700 rounded">
      {message}
    </div>
  )
}